var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"value":_vm.value,"color":_vm.color,"height":_vm.height,"reactive":"","striped":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }